export default __webpack_public_path__ + "static/media/img-banner02.95c97472.png";